module.exports = __webpack_public_path__ + "img/blibli.1d06581c.svg";